import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { messages_vi, messages_en } from './index'

const messages = {
  vi: messages_vi,
  en: messages_en
}

i18next.use(initReactI18next).init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: 'vi',
  resources: {
    vi: {
      translation: messages.vi
    },
    en: {
      translation: messages.en
    }
  },
  debug: process.env.NODE_ENV !== 'production',
  fallbackLng: 'vi'
})

export default i18next